import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center pa-4"
}
const _hoisted_4 = { class: "text-center pa-8 text-grey" }
const _hoisted_5 = {
  key: 0,
  class: "pagination-wrapper d-flex justify-center align-center pa-4"
}

import { ref, computed, watch, onMounted } from 'vue'
import { checkMobile } from '../../utils/utils'
import Notification from '../atoms_molecules/Notification.vue'
import { notificationState } from '../../stores/notification'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationList',
  setup(__props) {

const mobile = ref(false)
const currentPage = ref(1)
const itemsPerPage = ref(10)

const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: '通知',
    disabled: false,
    exact: true,
    to: '/classroom/notifications'
  }
]

const notifications = computed(() => notificationState.notifications)
const isLoading = computed(() => notificationState.isLoading)

const totalPages = computed(() => {
  return Math.ceil(notifications.value.length / itemsPerPage.value)
})

const paginatedNotifications = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return notifications.value.slice(start, end)
})

watch(notifications, () => {
  // Reset to first page when notifications change
  currentPage.value = 1
})

onMounted(() => {
  mobile.value = checkMobile()
  headerState.setTitle('通知')
  footerState.setFooterDefault()
  notificationState.getNotification({ checkNotification: true })
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: '通知' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "12",
        class: "bg-white pa-0"
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" Loading state "),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary"
                })
              ]))
            : (!notifications.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" Empty state "),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_icon, {
                      size: "48",
                      color: "grey-lighten-1",
                      class: "mb-3"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("mdi-bell-outline", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _cache[2] || (_cache[2] = _createElementVNode("p", null, "通知はありません", -1 /* CACHED */))
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" Notification list with pagination "),
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedNotifications.value, (item, index) => {
                        return (_openBlock(), _createBlock(Notification, {
                          item: item,
                          mobile: mobile.value,
                          key: index
                        }, null, 8 /* PROPS */, ["item", "mobile"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createCommentVNode(" Pagination "),
                  (totalPages.value > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_v_pagination, {
                          modelValue: currentPage.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                          length: totalPages.value,
                          "total-visible": mobile.value ? 5 : 7,
                          rounded: "circle",
                          density: "comfortable",
                          size: mobile.value ? 'small' : 'default'
                        }, null, 8 /* PROPS */, ["modelValue", "length", "total-visible", "size"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})